import React, { FunctionComponent, useEffect, useMemo, useState } from "react";
import { TeacherInfo } from "../../../../../store/onboarding/types";
import { Button, Form, InputGroup, Nav, OverlayTrigger, Popover, Tab, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faSearch } from "@fortawesome/free-solid-svg-icons";
import { ApplicationState } from "../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import {
  getDataSharingTableData,
  getDistrictRelationships,
  hideTeacherDetailsModal,
  openAssignEducatorsToEmployeeModal,
  openDataSharingEditModal,
} from "../../../../../store/onboarding/actions";
import { connect, useDispatch, useSelector } from "react-redux";
import { getFullName } from "../../../../../utils/NamesUtils";
import EducatorListItem from "./EducatorListItem";
import {
  StaffRelationship,
  UserAssignmentRole,
} from "../../../../../store/auth/types";
import { useLoading } from "../../../../../utils/hooks/useLoading";
import DataSharingEditModal from "../../../reading-interventions/educators-and-sharing/modals/DataSharingEditModal";
import LoadingIndicator from "../../LoadingIndicator";
import { EventKey } from "react-bootstrap/esm/types";

type StateProps = {
  selectedEmployee?: TeacherInfo;
  districtRelationships: Array<StaffRelationship>;
  showModal: boolean;
  isLoading: {
    getDistrictRelationships?: boolean;
  };
  // currentEducators: Array<TeacherInfo>;
  // previousEducators: Array<TeacherInfo>;
};

type DispatchProps = {
  hideTeacherDetailsModal: () => any;
  openAssignEducatorsToCoachModal: () => any;
  getDataSharingTableData: (userId: number) => any;
  getDistrictRelationships: (
    role: UserAssignmentRole.COACH | UserAssignmentRole.SUPERVISOR,
    userId: number
  ) => any;
};

type Props = StateProps & DispatchProps;

enum TabKeys {
  FIRST = "current_educators",
  SECOND = "previous_educators",
}

const EducatorsManagementTab: FunctionComponent<Props> = ({
  districtRelationships,
  selectedEmployee,
  showModal,
  isLoading,
  hideTeacherDetailsModal,
  getDistrictRelationships,
 // getDataSharingTableData,
  openAssignEducatorsToCoachModal,
}) => {
  const [activeTab, setActiveTab] = useState<string | null>(TabKeys.FIRST);
  const [currentEducatorSearchFilter, setcurrentEducatorSearchFilter] = useState<string>("");
  const [previousEducatorSearchFilter, setPreviousEducatorSearchFilter] = useState<string>("");
  const dispatch = useDispatch();
  
  const [selectedUser, setSelectedUser] = useState<any>();

  const handleEditRow = async (esd: any) => {
     await setSelectedUser(esd);
     dispatch(openDataSharingEditModal());
  };

  useEffect(() => {
    if (
      selectedEmployee &&
      selectedEmployee.user.profile.current_assignment?.role &&
      [UserAssignmentRole.COACH, UserAssignmentRole.SUPERVISOR].includes(
        selectedEmployee.user.profile.current_assignment.role
      )
    ) {
      getDistrictRelationships(
        selectedEmployee.user.profile.current_assignment.role as
          | UserAssignmentRole.COACH
          | UserAssignmentRole.SUPERVISOR,
        selectedEmployee.user.id
      );
    }
   // if(selectedEmployee) getDataSharingTableData(selectedEmployee.user.id)
  }, [selectedEmployee]);

  useEffect(() => {
    return () => {
      setcurrentEducatorSearchFilter("");
      setPreviousEducatorSearchFilter("");
    }
  }, [activeTab]);

  const handleAssignEducators = () => {
    hideTeacherDetailsModal();
    openAssignEducatorsToCoachModal();
  };

  const { currentEducators, previousEducators } = useMemo(() => {
    return districtRelationships.reduce(
      (pV, cV) => {
        if (cV.is_active) {
          return {
            ...pV,
            currentEducators: [...pV.currentEducators, cV],
          };
        } else {
          return {
            ...pV,
            previousEducators: [...pV.previousEducators, cV],
          };
        }
      },
      {
        currentEducators: [] as Array<StaffRelationship>,
        previousEducators: [] as Array<StaffRelationship>,
      }
    );
  }, [districtRelationships]);

   const getSorted = (a: StaffRelationship, b: StaffRelationship) => {
      const query = currentEducatorSearchFilter.toLowerCase();
  
      const aName = getFullName(a.child.user).toLowerCase();
      const bName = getFullName(b.child.user).toLowerCase();

      const aNameStarts = aName.startsWith(query);
      const bNameStarts = bName.startsWith(query);

      if (aNameStarts !== bNameStarts) {
        return aNameStarts ? -1 : 1;
      }

      const aNameIndex = aName.indexOf(query);
      const bNameIndex = bName.indexOf(query);

      return aNameIndex - bNameIndex;
    };

  return (
    <Tab.Container activeKey={activeTab as EventKey} onSelect={setActiveTab}>
      <div className="d-flex align-items-center">
        <Nav className="d-inline">
          <Nav.Item className="teacherDetailsTab">
            <Nav.Link eventKey={TabKeys.FIRST}>Current Educators
            {currentEducators.length > 0 && (
              <OverlayTrigger
                overlay={<Popover id="add-educator-tooltip" className="p-2">Assign educator(s) — changes apply immediately.</Popover>}
              >
                <Button onClick={handleAssignEducators} className="ml-2">
                  <FontAwesomeIcon icon={faPlusCircle} className="pointer" />
                </Button>
              </OverlayTrigger>
            )}</Nav.Link>
          </Nav.Item>
          <Nav.Item className="teacherDetailsTab">
            <Nav.Link eventKey={TabKeys.SECOND}>Previous Educators</Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
      <hr />   
      <Tab.Content>
        <Tab.Pane eventKey={TabKeys.FIRST}>
          {isLoading.getDistrictRelationships ? (
            <LoadingIndicator type="table" rows={9} columns={2} />
          ) : currentEducators.length ? (
            <div className="pl-0">
              <InputGroup className="filterSearchDesktop mb-3" size="sm">
                <InputGroup.Prepend>
                  <InputGroup.Text className="search-icon">
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Search"
                  className="filterSearchHeight"
                      value={currentEducatorSearchFilter as any}
                      onChange={(e) => setcurrentEducatorSearchFilter(e.target.value)}
                    />
                  </InputGroup>
                  <div
                    style={{
                      maxHeight: 342,
                      overflowY: "auto",
                      marginTop: 10,
                      scrollbarWidth: "thin"
                    }}
                    className="sticky-table-header-wrapper"
                >
                { currentEducators.length ? 
                <Table className="goalTable table-sm">
                  <thead>
                    <tr>
                      <th>EDUCATORS</th>
                      <th className="text-right">ACTIONS</th>
                    </tr>
                  </thead>
                <tbody>
                {currentEducators.filter((educator) => {
                  const fullName = getFullName(educator.child.user);
                  return fullName.toLowerCase().includes(currentEducatorSearchFilter.toLowerCase());
                }).sort(getSorted).map((educator, index) => (
                  <EducatorListItem
                    educator={educator.child.user}
                    eductorStaffRelation = {educator}
                    key={index}
                    onHandleEditRow={handleEditRow}
                  />
                ))}
                  </tbody>
                </Table> : '' }
              </div>
              </div>
          ) : (
            <div className="classSetupContainerEmpty">
              <div>
                <h4 className="mb-3">{`${selectedEmployee?.user.first_name} hasn't been assigned any educators yet`}</h4>
                <button onClick={handleAssignEducators} className="blueBtnSm">
                  ASSIGN EDUCATOR(S)
                </button>
              </div>
            </div>
          )}
          {(showModal && (selectedUser != undefined)) ?
             <DataSharingEditModal selectedUser={selectedUser} /> 
          : ''}
        </Tab.Pane>
        <Tab.Pane eventKey={TabKeys.SECOND}>
          {previousEducators.length > 0 ? (
              <div className="pl-0">
                <InputGroup className="filterSearchDesktop mb-3" size="sm">
                  <InputGroup.Prepend>
                    <InputGroup.Text className="search-icon">
                      <FontAwesomeIcon icon={faSearch} />
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={previousEducatorSearchFilter as any}
                    className="filterSearchHeight"
                    onChange={(e) => setPreviousEducatorSearchFilter(e.target.value)}
                  />
                </InputGroup>
                <div
                  style={{
                    maxHeight: 342,
                    overflowY: "auto",
                    marginTop: 10,
                    scrollbarWidth: "thin"
                  }}
                  className="sticky-table-header-wrapper"
                >
                {previousEducators.length > 0 ?
                <Table className="goalTable table-sm">
                  <thead>
                    <tr>
                      <th>EDUCATORS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {previousEducators.filter((educator) => {
                      const fullName = getFullName(educator.child.user);
                      return fullName.toLowerCase().includes(previousEducatorSearchFilter.toLowerCase());
                    }).sort(getSorted).map((educator) => (
                      <tr key={educator.id}>
                        <td>{getFullName(educator.child.user)}{" "}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table> : ''}
                </div>
              </div>
          ) : (
            <div className="classSetupContainerEmpty">
              <h4>{`${selectedEmployee?.user.first_name} hasn't had previous educators`}</h4>
            </div>
          )}
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  );
};

const mapStateToProps = ({ onboarding }: ApplicationState): StateProps => {
  return {
    selectedEmployee: onboarding.selectedTeacher,
    districtRelationships: onboarding.districtRelationships,
    showModal: onboarding.modalsState.dataSharingEditModal,
    isLoading: {
      getDistrictRelationships: onboarding.isLoading.getDistrictRelationships
    },
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  return bindActionCreators(
    {
      hideTeacherDetailsModal: hideTeacherDetailsModal,
      openAssignEducatorsToCoachModal: openAssignEducatorsToEmployeeModal,
      getDistrictRelationships: getDistrictRelationships,
      getDataSharingTableData: getDataSharingTableData
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EducatorsManagementTab);
